import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiDocumentText, HiArrowRightOnRectangle, HiIdentification, HiMapPin, HiExclamationTriangle, HiShieldCheck } from 'react-icons/hi2';
import SectionTitle from '../components/SectionTitle';
import InfoBox from '../components/InfoBox';
import TabGroup, { TabPanel } from '../components/TabGroup';

const EntryResidence = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <SectionTitle level={1} icon={HiDocumentText}>
        {t('entryResidence.title')}
      </SectionTitle>

      <TabGroup>
        {/* TAB 1: VOS DROITS */}
        <TabPanel tabId="rights">
          <section>
            <SectionTitle level={2} icon={HiShieldCheck}>
              {t('entryResidence.rightsTitle')}
            </SectionTitle>
            <div className="bg-teal-50 dark:bg-teal-900/20 border-l-4 border-teal-600 dark:border-teal-400 p-4 rounded-r-lg">
              <ul className="space-y-3">
                {t('entryResidence.rightsItems', { returnObjects: true }).map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1 font-bold">✓</span>
                    <span className="text-gray-900 dark:text-white font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section>
            <SectionTitle level={2} icon={HiArrowRightOnRectangle}>
              {t('entryResidence.entryRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('entryResidence.entryRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiIdentification}>
              {t('entryResidence.residenceRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('entryResidence.residenceRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiMapPin}>
              {t('entryResidence.circulationRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('entryResidence.circulationRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiArrowRightOnRectangle}>
              {t('entryResidence.exitRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('entryResidence.exitRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </TabPanel>

        {/* TAB 2: DÉMARCHES */}
        <TabPanel tabId="procedures">
          <section>
            <SectionTitle level={2} icon={HiArrowRightOnRectangle}>
              {t('entryResidence.enterTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('entryResidence.enterItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiIdentification}>
              {t('entryResidence.stayTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('entryResidence.stayItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiMapPin}>
              {t('entryResidence.circulateTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('entryResidence.circulateItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="demander" title={t('entryResidence.toAskTitle')}>
            <p>{t('entryResidence.toAskContent')}</p>
          </InfoBox>
        </TabPanel>

        {/* TAB 3: SI PROBLÈME */}
        <TabPanel tabId="problems">
          <section>
            <SectionTitle level={2} icon={HiExclamationTriangle}>
              {t('entryResidence.removalTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('entryResidence.removalItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="important" title={t('entryResidence.ifDecisionTitle')}>
            <ol className="space-y-2">
              {t('entryResidence.ifDecisionSteps', { returnObjects: true }).map((step, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-orange-600 dark:text-orange-400 font-bold mr-2">{index + 1}.</span>
                  <span className="text-gray-900 dark:text-white">{step}</span>
                </li>
              ))}
            </ol>
          </InfoBox>

          <InfoBox type="danger" title={t('entryResidence.urgentTitle')}>
            <p>{t('entryResidence.urgentContent')}</p>
          </InfoBox>
        </TabPanel>
      </TabGroup>
    </div>
  );
};

export default EntryResidence;
